import {gql} from '@apollo/client';

export const GET_REVENUE_METRICS = gql`
  query GetRevenueMetrics($filters: MetricsFilters!) {
    getRevenueMetrics(filters: $filters) {
      ... on ResponseWithRevenueMetrics {
        message
        data {
          totalRevenue {
            currency
            symbol
            amount
          }
          totalDabaProSubscriptionFees {
            currency
            symbol
            amount
          }
          totalOrderFees {
            currency
            symbol
            amount
            feeType
          }
          totalOrderDabaProFees {
            feeType
            symbol
            currency
            amount
          }
          totalDabaAcademySubscriptions {
            type
            symbol
            currency
            amount
          }
          totalSimulatorSubscriptions {
            currency
            type
            symbol
            amount
          }
        }
      }
      ... on Error {
        statusCode
        message
      }
    }
  }
`;

export const GET_WALLET_METRICS = gql`
  query GetWalletMetrics($filters: MetricsFilters!) {
    getWalletMetrics(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithWalletMetrics {
        message
        data {
          totalRevenue {
            currency
            symbol
            amount
          }
          grossDepositFees {
            currency
            symbol
            amount
          }
          grossWithdrawalFees {
            currency
            symbol
            amount
          }
          grossSwapFees {
            currency
            symbol
            amount
          }
        }
      }
    }
  }
`;

export const GET_ORDER_METRICS = gql`
  query GetOrderMetrics($filters: MetricsFilters!) {
    getOrderMetrics(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithOrderMetrics {
        message
        data {
          stocks {
            type
            total
            data
            list
          }
          mutualFunds {
            type
            total
            data
            list
          }
          bonds {
            type
            total
            data
            list
          }
          others {
            type
            total
          }
        }
      }
    }
  }
`;

export const GET_VOLUME_METRIC = gql`
  query GetVolumeMetrics($filters: MetricsFilters!) {
    getVolumeMetrics(filters: $filters) {
      ... on Error {
        statusCode
        message
      }
      ... on ResponseWithVolumeMetrics {
        message
        data {
          asset
          items {
            type
            currency
            symbol
            amount
          }
        }
      }
    }
  }
`;
